import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomButton } from './mixins'

interface ButtonsProps {
  onSave: () => void
  onCancel: () => void
  isValid: boolean
}

export const CartButtons = ({ onSave, onCancel, isValid }: ButtonsProps) => {
  const { t } = useTranslation()
  return (
    <>
      <CustomButton buttonoptions={{ size: 'small', type: 'outline', block: true }} onClick={onCancel}>
        {t('Seguir comprando')}
      </CustomButton>
      <CustomButton
        disabled={!isValid}
        buttonoptions={{ variant: 'primary', size: 'small', block: true }}
        onClick={onSave}
      >
        {t('Confirmar Compra')}
      </CustomButton>
    </>
  )
}
